import React, { useState } from "react";

let globalConfirmDialog = null;

const ConfirmDialog = ({ 
  title = "Confirm Action", 
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonClass = "bg-red-600 hover:bg-red-700",
  icon = "warning"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [item, setItem] = useState(null);
  const [resolvePromise, setResolvePromise] = useState(null);

  const openDialog = (itemToDelete) => {
    setItem(itemToDelete);
    setIsOpen(true);
    return new Promise((resolve) => {
      setResolvePromise(() => resolve);
    });
  };

  const handleConfirm = () => {
    setIsOpen(false);
    if (resolvePromise) resolvePromise(true);
    setResolvePromise(null);
    setItem(null);
  };

  const handleCancel = () => {
    setIsOpen(false);
    if (resolvePromise) resolvePromise(false);
    setResolvePromise(null);
    setItem(null);
  };

  // Register the dialog instance
  React.useEffect(() => {
    globalConfirmDialog = { openDialog };
    return () => {
      globalConfirmDialog = null;
    };
  }, []);

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm"
        onClick={handleCancel}
      />
      
      <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
        <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 pointer-events-auto">
          <div className="flex justify-center -mt-8">
            <div className={`w-16 h-16 rounded-full flex items-center justify-center shadow-lg ${
              icon === "warning" ? "bg-red-100" : "bg-yellow-100"
            }`}>
              <span className={`material-symbols-outlined text-3xl ${
                icon === "warning" ? "text-red-600" : "text-yellow-600"
              }`}>
                {icon === "warning" ? "warning" : "help"}
              </span>
            </div>
          </div>

          <div className="p-6 text-center">
            <h3 className="text-xl font-bold text-on-surface mb-2">{title}</h3>
            <p className="text-on-surface-variant text-sm leading-relaxed">
              {typeof message === 'function' ? message(item) : message}
            </p>
          </div>

          <div className="flex gap-3 p-6 pt-0">
            <button
              onClick={handleCancel}
              className="flex-1 px-4 py-2.5 border border-outline-variant text-on-surface-variant rounded-lg font-medium hover:bg-surface-container transition-colors"
            >
              {cancelText}
            </button>
            <button
              onClick={handleConfirm}
              className={`flex-1 px-4 py-2.5 text-white rounded-lg font-medium transition-all ${confirmButtonClass}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

// Helper function to show dialog from anywhere
export const showConfirmDialog = (item, options = {}) => {
  if (globalConfirmDialog) {
    return globalConfirmDialog.openDialog(item);
  }
  return Promise.reject(new Error("ConfirmDialog not mounted"));
};

export default ConfirmDialog;